import { gql } from '@apollo/client'

export const GET_SIMPLE_PRODUCTS = gql`
  query GetSimpleProducts(
    $filters: ProductFilter
    $pagination: OffsetLimitPaginationFilter
  ) {
    products(filters: $filters, pagination: $pagination) {
      totalCount
      results {
        id
        name
        preferredName
        packagingName
        upcA
        planogramImageUrl
        marketingImageUrl
        commonName {
          id
          name
        }
        brand {
          name
        }
        manufacturer {
          name
        }
        category {
          name
        }
        packaging {
          quantity
          size
          unit
          packagingString
        }
      }
    }
  }
`
